import { useContext } from "react";
import { useSelector } from "react-redux";
import { Drawer } from "antd";

import Context from "./Context";

import EN from "../../../../../config/en";
import Checkbox from "antd/lib/checkbox/Checkbox";

export default function ViewSettingsDrawer() {
  const {
    visibleViewSettingsDrawer,
    setVisibleViewSettingsDrawer,
    viewSettingsValues,
    setViewSettingsValues,
  } = useContext(Context);

  const onChangeSettingsValues = (event) => {
    viewSettingsValues[event.target.name] = event.target.checked;
    setViewSettingsValues({ ...viewSettingsValues });

    localStorage.setItem("MOVIE_COLUMNS", JSON.stringify(viewSettingsValues));
  };
  const translate = useSelector((state) => state.globalState.translate);

  return (
    <Drawer
      title={translate["View settings"] || EN["View settings"]}
      placement="right"
      onClose={() => setVisibleViewSettingsDrawer(false)}
      visible={visibleViewSettingsDrawer}
      destroyOnClose={true}
    >
      <h2>{translate["Show columns"] || EN["Show columns"]}</h2>

      <div className="view-settings-checkboxes">
        <Checkbox
          name="name"
          checked={viewSettingsValues.name}
          onChange={onChangeSettingsValues}
        >
          {translate["Name"] || EN["Name"]}
        </Checkbox>

        <Checkbox
          name="type"
          checked={viewSettingsValues.type}
          onChange={onChangeSettingsValues}
        >
          {translate["Type"] || EN["Type"]}
        </Checkbox>

        <Checkbox
          name="price"
          checked={viewSettingsValues.price}
          onChange={onChangeSettingsValues}
        >
          {translate["Price"] || EN["Price"]}
        </Checkbox>

        <Checkbox
          name="vod_geners"
          checked={viewSettingsValues.vod_geners}
          onChange={onChangeSettingsValues}
        >
          {translate["Genres"] || EN["Genres"]}
        </Checkbox>

        <Checkbox
          name="createdAt"
          checked={viewSettingsValues.createdAt}
          onChange={onChangeSettingsValues}
        >
          {translate["Date"] || EN["Date"]}
        </Checkbox>
      </div>
    </Drawer>
  );
}
